<template>
  <div class="page" id="featureDetailSecond" v-bind:class="{ 'show-mobile' : $vuetify.breakpoint.smAndDown }">
    <div class="featureDetail-body">
      <v-container class="body-inner">
        <v-row>
          <v-col cols="12" sm="7" class="img-box">
            <swiper ref="screenSwiper" :options="swiperOptions">
              <swiper-slide><img class="screen" src="../assets/screens/dummy.png" alt="screen" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/cheerful_msg.png" alt="cheerful-msg" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/info_msg.png" alt="information-msg" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/curated_msg.png" alt="curation-msg" /></swiper-slide>
              <swiper-slide><img class="screen" src="../assets/screens/dummy.png" alt="screen" /></swiper-slide>
            </swiper>
          </v-col>
          <v-col cols="12" sm="5" class="desc-box">
            <div class="page-nav">
            <ul class="featureDetail-menus">
              <li class="featureDetail-menu" v-for="(title, index) in featureSlides" v-bind:class="{ active : featureDetailSlideIndex === index }" v-bind:key="title" @click="moveTo(index)">{{title}}</li>
            </ul>
            </div>
            <swiper ref="descSwiper" :options="descSwiperOptions" :auto-update="true">
              <swiper-slide class="desc-slide slide-1" v-for="(desc,index) in descs" v-bind:key="index">
                <div class="desc-slide-inner d-flex justify-center align-start flex-column">
                  <p class="desc-title" v-html="desc.title"></p>
                  <p class="desc-text" v-html="desc.text"></p>
                </div>
              </swiper-slide>
            </swiper>
            <div class="desc-ref-box" v-if="!$vuetify.breakpoint.smAndDown">
              <span class="img-box">
                <img class="page-ramhee" src="../assets/cheerup.png" alt="ramhee" />
              </span>
              <span class="text-box">
                <p class="desc-ref">다이어트 프렌즈는 <strong>한국영양학회</strong>의 연구와 권장사항을 기준으로 정보를 제공하고 있습니다.</p>
              </span>
            </div>
            <div class="swiper-nav">
              <span class="swiper-nav-box left" v-if="featureDetailSlideIndex !== 0">
                <a class="swiper-nav-btn"><font-awesome-icon :icon="['fas','chevron-left']" @click="moveToPrev"></font-awesome-icon></a>
              </span>
                  <span class="swiper-nav-box right" v-if="featureDetailSlideIndex !== (descs.length - 1)">
                <a class="swiper-nav-btn"><font-awesome-icon :icon="['fas','chevron-right']" @click="moveToNext"></font-awesome-icon></a>
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
    export default {
        name: "FeatureDetailSecond",
        props: ['isFeatureDetailSecondPageScrolled'],
        watch: {
            isFeatureDetailPageScrolled: function (isCurrent) {
              isCurrent ? this.isShowBg = true : this.isShowBg = false;
          }
        },
        data: function () {
          let that = this;
          return {
            featureDetailSlideIndex: 0,
            featureSlides: ['멘탈 케어', '다이어트 정보', '맞춤 대화'],
            isShowBg: false,
            descs: [{
               title: '<strong>힘든 다이어트, 포기하고 싶을 때</strong><br/>람희가 응원할게요',
               text: '갑자기 야식 메뉴가 눈에 아른거려 괴로울 때, 다이어트 성과가 보이지 않아 지칠 때 람희와 대화해 보세요. 따뜻한 격려와 응원은 물론 해결 방법까지 알려준답니다.',
            }, {
                title: '<strong>다이어트 상식, 바로 알고 싶을 때</strong> <br/>람희에게 물어보세요',
                text: '1일 1식, 저탄고지, 원푸드 다이어트 등 너무 많은 정보와 방법들에 다이어트 시작도 전에 지치셨나요? 람희는 한국영양학회의 연구와 기준을 바탕으로 제대로 된 다이어트 정보만 알려드려요.',
            }, {
                title: '<strong>갑작스런 상황, 해결책이 필요할 때</strong><br/>람희와 대화하세요',
                text: '어제 짜게 먹었나요? 아니면 오늘 갑자기 외식을 하게 되었나요? 그럴 때 람희와 이야기를 나누다 보면 내 상황에 필요한 조언과 정보를 알려줘요. 똑똑한 람희와 함께라면 이번 다이어트는 성공 확률 200%!',
            }],
            swiperOptions: {
                loop: false,
                initialSlide: 0,
                slidesPerView: 3,
                slidesPerGroup: 1,
                loopFillGroupWithBlank: true,
                on: {
                    slideChangeTransitionStart: (e) => {
                        that.featureDetailSlideIndex = e.activeIndex;
                        that.descSwiper.slideTo(e.activeIndex);
                    }
                }
            },
            descSwiperOptions: {
                initialSlide: 0,
                loop: false,
                resistance: false,
                on: {
                    slideChangeTransitionStart: (e) => {
                        that.featureDetailSlideIndex = e.activeIndex;
                        that.swiper.slideTo(e.activeIndex);
                    }
                }
            },
          }
        },
        methods: {
          moveTo: function(index) {
            this.swiper.slideTo(index);
            this.descSwiper.slideTo(index);
          },
          moveToPrev: function() {
            this.featureDetailSlideIndex > 0 ? this.moveTo((this.featureDetailSlideIndex - 1)) : false;
          },
          moveToNext: function() {
              this.featureDetailSlideIndex < (this.descs.length - 1) ? this.moveTo((this.featureDetailSlideIndex + 1)) : false;
          },
        },
        computed: {
            swiper() {
                return this.$refs.screenSwiper.$swiper;
            },
            descSwiper() {
                return this.$refs.descSwiper.$swiper;
            }
        },
        mounted() {
            this.$vuetify.breakpoint.mobile ? this.swiper.allowTouchMove = true : this.swiper.allowTouchMove = false;
        }
    }
</script>

<style lang="scss" scoped>
@import '../variables.scss';
#featureDetailSecond.show-mobile {
  overflow: visible !important;
  height: auto !important;
  .img-box {
    order: 2;
    height: auto !important;
    .desc-ref-box {
      display: block;
      margin-top: 1rem;
      padding-left: 1.5rem;
      .desc-ref {
        margin: 0;
        font-size: 0.8em;
        color: $softBlueColor;
      }
    }
  }
  .desc-box {
    margin-top: -50px !important;
    order: 1;
    height: auto !important;
    .featureDetail-menus {
      margin-bottom: 1rem !important;
    }
    .desc-title {
      font-size: 1.6em !important;
    }
    .page-ramhee {
      display: none !important;
    }
  }
}
#featureDetailSecond {
  padding: 4rem 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: $defaultBackgroundColor;
  /*animate object*/
  .showBg-enter-active {
    animation: fade-in-top .5s;
  }
  .showBg-leave-active {
    animation: fade-in-top .5s reverse;
  }
  .featureDetail-body {
    position: relative;
    height: 100%;
    width: 100%;

    .body-inner {
      height: 100%;
      position: relative;
      .row {
        height: 100%;
        padding: 0;

        > div {
          height: 100%;
        }
      }
    }
    .swiper-container{
      width: 100%;
      height: 100%;
      position: relative;
      justify-content: flex-start;
      align-items: center;
      flex-direction: row;
      display: flex;
      overflow: hidden;
    }

    .img-box {
      width: 100%;
      position: relative;
      .swiper-slide {
        opacity: 0.44;
        height: 100%;
        width: 100%;
        z-index: 9;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        display: flex;
        img {
          height: auto;
          width: 76%;
          border: $basicBorder;
          border-radius: 4px;
        }
      }
      .swiper-slide.swiper-slide-next {
        opacity: 1;
        height: 100%;
        z-index: 99;
        img {
          height: auto;
          width: 100%;
        }
      }
      .swiper-slide.swiper-slide-active {
      }
    }
    .desc-box {
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .swiper-container {
        height: auto;
      }

      .swiper-nav {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 0;
        display: none;

        .swiper-nav-btn {
          font-size: 1.4em;
          color: $softBlueColor;
          padding: 1rem;
          z-index: 999;
        }
        .swiper-nav-box {
          position: absolute;
          transform: translate(-60%,0);
          bottom: 60%;
        }
        .swiper-nav-box.left {
          left: 10px;
        }
        .swiper-nav-box.right {
          right: -48px;
        }
      }
      .page-nav {
        display: flex;
        justify-content: center;
        align-items: flex-start;
        flex-direction: column;
        margin-bottom: 1rem;
      }
      .featureDetail-menus {
        display: flex;
        flex-direction: row;
        padding-left: 2rem;
        margin-bottom: 2rem;

        .featureDetail-menu {
          font-size: 1em;
          font-family: $basicFont;
          font-weight: bold;
          margin-right: 0.4rem;
          padding: 0.6rem;
          color: $basicFontColor;
          cursor: pointer;
          border-bottom: 2px solid transparent;
        }
        .active {
          color: black;
          border-bottom: 2px solid $primaryBlueColor;
        }
      }
      .page-title-box {
        padding-left: 2rem;
        margin-bottom: 1rem;
        .page-ramhee {
          width: auto;
          height: 160px;
          margin-left: -1.4rem;
          display: inline-block;
        }
        .page-title {
          text-align: center;
          font-size: 2em;
          font-family: $brandFont;
          color: $basicFontColor;
          margin: 0;
          display: inline-block;
        }
      }
      .desc-ref-box {
        margin-top: 1rem;
        padding-left: 1.5rem;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .img-box {
          width: auto;
          .page-ramhee {
            padding-right: 2rem;
            width: auto;
            height: 60px;
            display: inline-block;
          }
        }
        .text-box {
        }
        .desc-ref {
          margin: 0;
          font-size: 0.8em;
          line-height: 1.6em;
          max-width: 66%;
          color: $softBlueColor;
          word-break: keep-all;
        }
      }
      .desc-slide {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;

        .desc-slide-inner {
          padding: 0 1rem 0 2rem;
        }
        .desc-title {
          font-size: 1.8em;
          font-weight: normal;
          font-family: $basicFont;
          color: $basicFontColor;
          margin-bottom: 1rem;
        }
        .desc-text {
          word-break: keep-all;
          max-width: 400px;
          font-color: $basicFontColor;
          font-family: $basicFont;
          font-size: 1em;
          width: 100%;
          line-height: 2em;
          text-align: justify;
        }
      }
    }
  }
}
</style>
